import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGlobalState } from '../../../store';
import SyncCreatePage from './SyncCreatePage';

const SyncEditPage = () => {
  const { syncId } = useParams();
  const [accounts] = useGlobalState('accounts');
  const [license] = useGlobalState('license');
  const [syncs] = useGlobalState('syncs');
  const navigate = useNavigate();
  
  // Decode the syncId if it's URL encoded
  const decodedSyncId = decodeURIComponent(syncId);
  
  return (
    <SyncCreatePage 
      id={decodedSyncId} 
      accounts={accounts} 
      license={license} 
      syncs={syncs}
      navigate={navigate}
    />
  );
};

export default SyncEditPage;
